<template>
  <div class="block" ref="extraDetailsContainer">
    <button class="additional-options" @click="toggleWindow">
      <div class="title" :class="{ open: isExtraDetailsVisible }">
        <img src="/images/redesignedForm/additional.svg" alt="additional" />
        <span class="extras-heading">Дополнительные опции</span>
        <img src="/images/redesignedForm/additional.svg" alt="additional" />
      </div>
      <div class="description">
        <span>Доплата от заказчика, наименование организации, номер внутреннего заказа</span>
      </div>
    </button>
    <transition name="smooth-render">
      <div class="additional-wrap" v-if="isExtraDetailsVisible">
        <div class="wrap">
          <div class="block-title left">
            <h3>Доплата от заказчика</h3>
          </div>
          <div class="paid-delivery">
            <div class="string">
              <div class="fields one">
                <div class="order-input input-group input-group-right">
                  <input
                    type="text"
                    v-model="courierAddition"
                    @keypress="onlyNumber"
                    :class="getErrorClass('courierAddition')"
                    ref="courierAdditionField"
                  />
                  <input type="text" value="₽" disabled="disabled" />
                </div>
              </div>
            </div>
          </div>
          <div class="block-title left">
            <h3>Организация</h3>
          </div>
          <div class="paid-delivery">
            <div class="string">
              <div class="fields one">
                <div class="order-input">
                  <input type="text" placeholder="Например, Юлмарт" v-model="shopName" />
                </div>
              </div>
            </div>
          </div>
          <div class="block-title left">
            <h3>Номер заказа</h3>
          </div>
          <div class="paid-delivery">
            <div class="string">
              <div class="fields one">
                <div class="order-input">
                  <input type="text" placeholder="Внутренний номер" v-model="shopInnerId" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ValidationView :error-messages="getErrorMessages('courierAddition')" />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'
import { maxValue, helpers } from '@vuelidate/validators'
import { GENERAL_STORE } from '@apps/order-form/src/store'
import preventNoNumbers from '@utils/preventNoNumbers'
import validationMixinGeneral from '@apps/order-form/src/mixins/validationMixinGeneral'

export default {
  name: 'ExtraDetails',
  validations() {
    return {
      courierAddition: {
        maxValue: helpers.withMessage(
          'Максимальная сумма доплаты от заказчика: 1000 руб.',
          maxValue(1000)
        ),
      },
    }
  },
  mounted() {
    this.addFieldValidator('courierAddition', this.$refs.extraDetailsContainer)
  },
  mixins: [validationMixinGeneral],
  computed: {
    ...mapState(GENERAL_STORE, ['order', 'isExtraDetailsVisible']),
    courierAddition: {
      get() {
        return this.order.shop.surcharge
      },
      set(value) {
        this.updateShop({ key: 'surcharge', value: +value })
        this.calculatePrice()
        // this.updateOrder({ key: 'courierAddition', value });
        // <<<<<<<
        // this.validateForm();
      },
    },
    shopName: {
      get() {
        return this.order.shop.name
      },
      set(value) {
        this.updateShop({ key: 'name', value })
      },
    },
    shopInnerId: {
      get() {
        return this.order.shop.orderInnerId
      },
      set(value) {
        this.updateShop({ key: 'orderInnerId', value })
      },
    },
  },
  methods: {
    ...mapMutations(GENERAL_STORE, ['updateShop', 'updateState']),
    ...mapActions(GENERAL_STORE, ['calculatePrice']),
    toggleWindow() {
      this.updateState({
        key: 'isExtraDetailsVisible',
        value: !this.isExtraDetailsVisible,
      })
    },
    onlyNumber(e) {
      preventNoNumbers(e)
    },
  },
}
</script>

<style scoped>
.smooth-render-enter,
.smooth-render-leave-to {
  transform: scale(0);
}

.smooth-render-enter-to,
.smooth-render-leave {
  transform: scale(1);
}

.smooth-render-enter-active,
.smooth-render-leave-active {
  transition: opacity, 0.3s linear;
  transition: transform 0.3s linear;
}

.extras-heading {
  font-weight: 700;
}
</style>
